import {Component, Input, OnInit} from '@angular/core';
import {EntityInformationRestService} from '../../../../shared/services/nso-data-portal/rest-services/entity-information-rest.service';
import {CensusData} from '../../../../shared/types/nso-data-portal/census-data';
import {SearchEntityLevels} from '../../../../shared/types/nso-data-portal/search-entity-levels';
import {GlobalMessagesService} from '../../../../shared/services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import {ExportTypes} from '../../../../shared/types/nso-data-portal/export-types';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {FormHelperService} from '../../../../shared/services/person/form-helper-service';
import {FileUtilsService} from '../../../../shared/services/common/file/file-utils.service';

@Component({
  selector: 'wsd-census-export',
  templateUrl: './census-export.component.html',
  styleUrls: ['./census-export.component.css']
})
export class CensusExportComponent implements OnInit {

  @Input()
  censusData: CensusData;

  @Input()
  entityId: number;

  @Input()
  lastCensusYear: number;

  @Input()
  isNSO: boolean;

  @Input()
  isFederation: boolean;

  @Input()
  entityLevel: SearchEntityLevels;

  rangeForm: UntypedFormGroup;

  currentYear = new Date().getFullYear();

  entityExportChoice: SearchEntityLevels;

  searchEntityLevels = SearchEntityLevels;

  exportTypes = ExportTypes;

  yearChoiceType: ExportTypes = ExportTypes.SINGLE;

  block: boolean = false;

  constructor(private entityRestService: EntityInformationRestService,
              private translate: TranslateService,
              private globalMessageService: GlobalMessagesService,
              private formBuilder: UntypedFormBuilder,
              private formHelper: FormHelperService,
              private fileUtils: FileUtilsService) {
  }

  ngOnInit() {
    this.initExportRangeForm();
    this.entityExportChoice = this.isNSO ? SearchEntityLevels.FEDERATION : this.entityLevel;
    if (this.entityLevel === SearchEntityLevels.WORLD) {
      this.entityExportChoice = SearchEntityLevels.WORLD;
    }
    if (this.entityLevel === SearchEntityLevels.REGION) {
      this.entityExportChoice = SearchEntityLevels.REGION;
    }
  }

  initExportRangeForm() {
    this.rangeForm = this.formBuilder.group({
      yearFrom: [this.lastCensusYear, [Validators.required, Validators.min(1900), Validators.max(this.lastCensusYear)]],
      yearTo: [this.lastCensusYear, [Validators.max(this.lastCensusYear)]],
    }, {
      validator: (fg: UntypedFormGroup) => {
        if (this.yearChoiceType === this.exportTypes.SINGLE) {
          return true;
        }
        const start = fg.get('yearFrom').value;
        const end = fg.get('yearTo').value;
        return start !== null && end !== null && start < end
          ? null
          : {range: true};
      }
    });
  }

  exportXLS() {
    this.formHelper.validateAllFormFields(this.rangeForm);
    if (this.rangeForm.invalid) {
      this.globalMessageService.showErrorMessage(
        this.translate.instant('DATA_PORTAL.CENSUS.DETAIL.EXPORT_RANGE_VALIDITY_ERROR')
      );
      return;
    }
    this.block = true;
    this.entityRestService.exportEntityHistory(
      {
        entityId: this.entityId,
        entityRestLevel: this.entityLevel,
        yearFrom: this.rangeForm.value.yearFrom,
        yearTo: this.yearChoiceType === this.exportTypes.SINGLE ? this.rangeForm.value.yearFrom : this.rangeForm.value.yearTo,
        entityExportChoiceLevel: this.entityExportChoice
      }).subscribe(
      response => {
        this.block = false;
        FileSaver.saveAs(response.body, this.fileUtils.extractFileName(response));
      },
      () => {
        this.block = false;
        this.globalMessageService.showErrorMessage(
          this.translate.instant('DATA_PORTAL.CENSUS.DETAIL.EXPORT_ERROR')
        );
      }
    )
    ;
  }
}


